// @generated by protoc-gen-es v1.6.0 with parameter "target=js"
// @generated from file dymensionxyz/dymension/gamm/pool-models/balancer/balancerPool.proto (package dymensionxyz.dymension.gamm.v1beta1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

// this is a legacy package that requires additional migration logic
// in order to use the correct packge. Decision made to use legacy package path
// until clear steps for migration logic and the unknowns for state breaking are
// investigated for changing proto package.

import { Duration, proto3, Timestamp } from "@bufbuild/protobuf";
import { Coin } from "./coin_pb";

/**
 * Parameters for changing the weights in a balancer pool smoothly from
 * a start weight and end weight over a period of time.
 * Currently, the only smooth change supported is linear changing between
 * the two weights, but more types may be added in the future.
 * When these parameters are set, the weight w(t) for pool time `t` is the
 * following:
 *   t <= start_time: w(t) = initial_pool_weights
 *   start_time < t <= start_time + duration:
 *     w(t) = initial_pool_weights + (t - start_time) *
 *       (target_pool_weights - initial_pool_weights) / (duration)
 *   t > start_time + duration: w(t) = target_pool_weights
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.SmoothWeightChangeParams
 */
export const SmoothWeightChangeParams = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.SmoothWeightChangeParams",
  () => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "duration", kind: "message", T: Duration },
    { no: 3, name: "initial_pool_weights", kind: "message", T: PoolAsset, repeated: true },
    { no: 4, name: "target_pool_weights", kind: "message", T: PoolAsset, repeated: true },
  ],
);

/**
 * PoolParams defined the parameters that will be managed by the pool
 * governance in the future. This params are not managed by the chain
 * governance. Instead they will be managed by the token holders of the pool.
 * The pool's token holders are specified in future_pool_governor.
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.PoolParams
 */
export const PoolParams = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.PoolParams",
  () => [
    { no: 1, name: "swap_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "exit_fee", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "smooth_weight_change_params", kind: "message", T: SmoothWeightChangeParams },
  ],
);

/**
 * Pool asset is an internal struct that combines the amount of the
 * token in the pool, and its balancer weight.
 * This is an awkward packaging of data,
 * and should be revisited in a future state migration.
 *
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.PoolAsset
 */
export const PoolAsset = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.PoolAsset",
  () => [
    { no: 1, name: "token", kind: "message", T: Coin },
    { no: 2, name: "weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message dymensionxyz.dymension.gamm.v1beta1.Pool
 */
export const Pool = proto3.makeMessageType(
  "dymensionxyz.dymension.gamm.v1beta1.Pool",
  () => [
    { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "pool_params", kind: "message", T: PoolParams },
    { no: 4, name: "future_pool_governor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "total_shares", kind: "message", T: Coin },
    { no: 6, name: "pool_assets", kind: "message", T: PoolAsset, repeated: true },
    { no: 7, name: "total_weight", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

